// import $ from 'jquery';
import React from 'react';
import { string, bool, func } from 'prop-types';
import {
    Menu,
    ClearRefinements
} from 'react-instantsearch-dom';

export default class DropdownFilter extends React.Component {
    constructor(props) {
        super(props);

        this.handleTitleClick = this.handleTitleClick.bind(this);
        this.state = {
            title: props.attribute,
            isOpen: false
        };
    }

    // eslint-disable-next-line consistent-return
    handleTitleClick(e) {
        let text = this.state.title;
        if (e.target.closest('.ais-Menu-link')) {
            text = e.target.closest('.ais-Menu-link').querySelector('.ais-Menu-label').textContent;
        } else if (e.target.className === 'ais-ClearRefinements-button') {
            text = this.props.attribute;
        }

        this.setState({
            title: text,
            isOpen: !this.state.isOpen
        });

        this.props.toggleActiveFilter(this.props.attribute, false);
    }

    render() {
        let text = this.state.title;
        if (this.props.reset) {
            text = this.props.attribute;
        }

        const resetText = this.props.attributePlural ? this.props.attributePlural : `${this.props.attribute}s`;
        return (
            <div className={`dropdown-wrapper dropdown-filter filter-item algolia-dropdown-filter${this.state.isOpen ? ' is-open' : ''}`}>
                <div className="EditingFormValueCell">
                    <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                        <div
                            className="select"
                            role="combobox"
                            aria-controls={this.props.attribute}
                            aria-expanded="false"
                            tabIndex="0"
                            onClick={this.handleTitleClick}
                            onKeyPress={this.handleTitleClick}
                        >
                            <p className="dropdown-filter-title-text">
                                {this.props.attributePseudonym ? this.props.attributePseudonym : text}
                            </p>
                        </div>
                        <div
                            className="dropdown-filter-panel"
                            id={this.props.attribute}
                            onClick={this.handleTitleClick}
                            onKeyPress={this.handleTitleClick}
                            role="combobox"
                            aria-controls={this.props.attribute}
                            aria-expanded="false"
                            tabIndex="0"
                        >
                            {this.props.disableShowAll ? '' : (
                                <ClearRefinements
                                    transformItems={items =>
                                        items.filter(({ attribute }) => attribute === this.props.attribute)
                                    }
                                    translations={{ reset: `show all ${resetText}` }}
                                    clearsQuery={true}
                                />)}
                            {this.props.attribute === 'year' ?
                                <Menu
                                    attribute={this.props.attribute}
                                    limit={40}
                                    transformItems={items =>
                                        items.sort((a, b) => b.label - a.label)
                                    }
                                />
                                :
                                <Menu
                                    attribute={this.props.attribute}
                                    limit={40}
                                    transformItems={items =>
                                        items.sort((a, b) => {
                                            const textA = a.label.toUpperCase();
                                            const textB = b.label.toUpperCase();
                                            // eslint-disable-next-line no-nested-ternary
                                            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                                        })
                                    }
                                />
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

/* eslint-disable react/no-typos */
/* eslint-disable react/forbid-prop-types */
DropdownFilter.propTypes = {
    attribute: string.isRequired,
    attributePlural: string,
    reset: bool,
    toggleActiveFilter: func.isRequired,
    attributePseudonym: string,
    disableShowAll: bool
};

DropdownFilter.defaultProps = {
    reset: false,
    attributePlural: '',
    attributePseudonym: '',
    disableShowAll: false
};



// WEBPACK FOOTER //
// ./src/sections/algolia-filter/dropdown-filter/index.jsx